<template>
  <div class="quickReservationDialog">
    <el-dialog
      title="快捷预约"
      :visible.sync="visible"
      width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="dialog_form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="预约项目：" prop="physioIds">
            <el-checkbox-group class="form_checkbox_group" v-model="form.physioIds" @change="productChange">
              <el-checkbox v-for="item in productList" :key="item.physioId" class="form_checkbox" :label="item.physioId">{{ item.physioName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="执行人：" prop="doctorId">
            <el-select class="form_input" v-model="form.doctorId" filterable placeholder="请选择" @change="doctorChange">
              <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约日期：" prop="reservationDateTime">
            <el-date-picker
              class="form_input"
              v-model="form.reservationDateTime"
              type="date"
              :picker-options="pickerOptions"
              :editable="false"
              :disabled="[null, undefined, ''].includes(form.doctorId)"
              placeholder="选择预约日期"
              value-format="yyyy-MM-dd"
              popper-class="physio_reservation_date_picker"
              @change="reservationDateChange">
            </el-date-picker>
          </el-form-item>
          <div v-if="form.physioIds.length > 0 && ![null, undefined, ''].includes(form.doctorId) && ![null, undefined, ''].includes(form.reservationDateTime)">
            <el-form-item class="form_item_times" label="预约时段：" required>
              <div v-if="schedulingList.length === 0">暂无可选排班</div>
            </el-form-item>
            <div class="scheduling">
              <div v-for="classes in schedulingList" :key="classes.timeType" class="scheduling_classes">
                <div class="scheduling_classes_name">{{ classes.timeTypeName }}</div>
                <div class="scheduling_list">
                  <div
                    v-for="scheduling in classes.list"
                    :key="scheduling.vId"
                    :class="{ scheduling_item: true, active: scheduling.vId === form.schedulingItemVId, disabled: scheduling.disabled }"
                    @click="selectScheduling(scheduling.vId)">
                    <div class="scheduling_item_time">{{ scheduling.appointmentStartTimeText }}-{{ scheduling.appointmentEndTimeText }}</div>
                    <div class="scheduling_item_status">{{ scheduling.describe }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getReservationScheduling, postPhysioReservation } from '@/api/physio.js'
  import req from '@/utils/request'

  const timeTypeMap = {
    '1': '上午',
    '2': '中午',
    '3': '下午',
    '4': '晚上'
  }

  export default {
    name: 'quickReservationDialog',
    data () {
      return {
        visible: false,
        loading: false,
        orderId: '',
        orderNumber: '',
        patientId: '',
        productList: [],
        doctorOptions: [],
        physioSchedulingDayStatusList: [],
        pickerOptions: {
          disabledDate: (time) => {
            const minDate = new Date()
            let maxDate = new Date()
            maxDate.setDate(1)
            maxDate.setDate(64)
            maxDate.setDate(0)

            const startDate = minDate.Format('yyyy-MM-dd')
            const endDate = maxDate.Format('yyyy-MM-dd')

            if (time.Format('yyyy-MM-dd') < startDate || time.Format('yyyy-MM-dd') > endDate) {
              return true
            } else {
              const day = time.Format('yyyy-MM-dd')
              const status = this.physioSchedulingDayStatusList.find(v => v.date === day)
              if (status) {
                return true
              } else {
                return false
              }
            }
          },
          cellClassName: this.setReservationDateCellClass
        },
        sourceSchedulingList: [],
        schedulingList: [],
        rules: {
          physioIds: [{ required: true, message: '请选择预约项目', trigger: 'change' }],
          doctorId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
          reservationDateTime: [{ required: true, message: '请选择预约时间', trigger: 'change' }]
        },
        form: {
          physioIds: [],
          doctorId: '',
          reservationDateTime: '',
          schedulingItemVId: ''
        }
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      open (options) {
        if (options.orderId) {
          this.orderId = options.orderId
        }
        if (options.orderNumber) {
          this.orderNumber = options.orderNumber
        }
        if (options.patientId) {
          this.patientId = options.patientId
        }
        if (options.productList) {
          this.productList = options.productList
          this.form.physioIds = options.productList.map(v => { return v.physioId })
        }
        this.$getDoctorOptions()
        this.visible = true
      },
      async getScheduling () {
        if (this.form.physioIds.length > 0 && ![null, undefined, ''].includes(this.form.doctorId) && ![null, undefined, ''].includes(this.form.reservationDateTime)) {
          const res = await getReservationScheduling({
            deptId: sessionStorage.getItem('deptId'),
            orderNumber: this.orderNumber,
            physioIds: this.form.physioIds,
            doctorId: this.form.doctorId,
            reservationDateTime: this.form.reservationDateTime
          })
          if (res.code === 200) {
            const source = res.data.map(v => {
              v['vId'] = this.generateUUID()
              v['date'] = new Date(v.appointmentStartDateTime).Format('yyyy-MM-dd')
              v['appointmentStartDateTime'] = new Date(v.appointmentStartDateTime).Format('yyyy-MM-dd hh:mm:ss')
              v['appointmentEndDateTime'] = new Date(v.appointmentEndDateTime).Format('yyyy-MM-dd hh:mm:ss')
              v['appointmentStartTimeText'] = new Date(v.appointmentStartDateTime).Format('hh:mm')
              v['appointmentEndTimeText'] = new Date(v.appointmentEndDateTime).Format('hh:mm')
              v['timeTypeName'] = timeTypeMap[v.timeType]

              const bookedRecord = v.reservationNoticeBoardTimes.find(record => {
                return (this.patientId === record.patientId) && (this.orderId === record.orderId) && (new Date(record.reservationStartTime).Format('yyyy-MM-dd hh:mm:ss') === v.appointmentStartDateTime)
              })

              v['bookedStatus'] = !['', undefined, null].includes(bookedRecord)
              v['releaseStatus'] = true
              v['disabled'] = false
              v['describe'] = '可约'
              switch (true) {
                case v.status === '1':
                  v.describe = '停诊'
                  v.disabled = true
                  break
                case !v.releaseStatus:
                  v.describe = '未放号'
                  v.disabled = true
                  break
                case new Date(v.appointmentEndDateTime).getTime() < new Date().getTime():
                  v.describe = '完诊'
                  v.disabled = true
                  break
                case v.bookedStatus:
                  v.describe = '已约'
                  v.disabled = true
                  break
                case !v.useReservation:
                  v.describe = '约满'
                  v.disabled = true
                  break
              }
              return v
            })

            this.sourceSchedulingList = source

            this.schedulingList = source.reduce((res, cur) => { 
              const resType = res.find(v => v.timeType === cur.timeType)
              if (resType) {
                resType.list.push(cur)
              } else {
                res.push({
                  timeType: cur.timeType,
                  timeTypeName: cur.timeTypeName,
                  list: [cur]
                })
              }
              return res
            }, [])
          }
        }
      },
      productChange () {
        this.sourceSchedulingList = []
        this.schedulingList = []
        this.form.schedulingItemVId = ''
        this.getScheduling()
      },
      doctorChange () {
        this.sourceSchedulingList = []
        this.schedulingList = []
        this.form.schedulingItemVId = ''

        this.form.reservationDateTime = ''
        this.getPhysioSchedulingDayStatus()
      },
      setReservationDateCellClass (date) {
        const day = new Date(date).Format('yyyy-MM-dd')
        const status = this.physioSchedulingDayStatusList.find(v => v.date === day)
        if (status) {
          return `date-picker_reservation_cell_${status.status}`
        }
      },
      async getPhysioSchedulingDayStatus () {
        const minDate = new Date()
        let maxDate = new Date()
        maxDate.setDate(1)
        maxDate.setDate(64)
        maxDate.setDate(0)

        const dayNum = (Math.ceil((maxDate - minDate) / (1000 * 60 * 60 * 24))) + 1

        const res = await req.get('/physioReservation/queryPhysioSchedulingDayStatus', {
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.form.doctorId,
          dayNum: dayNum
        })
        if (res.code === 200) {
          this.physioSchedulingDayStatusList = res.data && res.data.filter(v => (v.status !== 1 && v.status !== 3)) || []
        }
      },
      reservationDateChange () {
        this.sourceSchedulingList = []
        this.schedulingList = []
        this.form.schedulingItemVId = ''
        this.getScheduling()
      },
      selectScheduling (vId) {
        const scheduling = this.sourceSchedulingList.find(v => v.vId === vId)
        if (scheduling.disabled) {
          return false
        }
        this.form.schedulingItemVId = vId
      },
      close () {
        this.visible = false
        this.orderNumber = ''
        this.productList = []
        this.sourceSchedulingList = []
        this.schedulingList = []
        this.form.physioIds = []
        this.form.doctorId = ''
        this.form.reservationDateTime = ''
        this.form.schedulingItemVId = ''
      },
      submit () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            if ([null, undefined, ''].includes(this.form.schedulingItemVId)) {
              this.$message.error('请选择预约时段')
              return
            }
            const scheduling = this.sourceSchedulingList.find(v => v.vId === this.form.schedulingItemVId)
            if (scheduling) {
              this.loading = true
              const res = await  postPhysioReservation({
                deptId: sessionStorage.getItem('deptId'),
                orderNumber: this.orderNumber,
                physioIds: this.form.physioIds,
                doctorId: this.form.doctorId,
                schedulingItemId: scheduling.schedulingItemId,
                startTime: scheduling.appointmentStartDateTime,
                endTime: scheduling.appointmentEndDateTime,
                source: 'platform'
              })
              this.loading = false
              if (res.code === 200) {
                this.$message.success('预约成功')
                this.close()
              }
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .quickReservationDialog {
    overflow: hidden;
  }

  .quickReservationDialog /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #E5E6EB !important;
  }

  .quickReservationDialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }
  
  .quickReservationDialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .quickReservationDialog /deep/ .el-dialog__footer {
    padding: 12px 20px;
  }

  .content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .dialog_form {
    overflow: hidden;
  }

  .dialog_form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .dialog_form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_checkbox_group {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .form_checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
    overflow: hidden;
  }

  .form_input {
    width: 360px;
  }

  .form_item_times {
    margin: 0 0 0 0;
  }

  .scheduling {
    margin: 4px 0 0 0;
    width: 100%;
    overflow: hidden;
  }

  .scheduling_classes {
    width: 100%;
  }

  .scheduling_classes+.scheduling_classes {
    margin: 16px 0 0 0;
  }

  .scheduling_classes_name {
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }

  .scheduling_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 8px -12px -12px 0;
    width: calc(100% + 12px);
  }

  .scheduling_item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 12px 12px 0;
    width: 141px;
    height: 50px;
    background-color: #FFFFFF;
    border: 1px solid #D5D5D5;
    border-radius: 6px;
    cursor: pointer;
  }

  .scheduling_item.active {
    background-color: #FFF5EA;
    border-color: #E3874F;
  }

  .scheduling_item.disabled {
    background-color: #EAE9E9;
    opacity: 0.4;
  }

  .scheduling_item_time {
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
  }

  .scheduling_item_status {
    line-height: 14px;
    font-size: 10px;
    color: #1F2329;
  }
</style>